import CreateModal from './CreateModal';

export default CreateModal;
